export default __webpack_public_path__ + "6b49b61ecf0033744e534f93385bb706.svg";